(function () {
  if (window.__cintaRecommendationClicksBound) return;
  window.__cintaRecommendationClicksBound = true;

  var endpoint = 'https://mansa-intima-backend.invalid/outros-sites/gerenciar-pedidos-shopify/api/product-recommendation-click.php';
  var selector = '[data-product-recommendation-click]';
  var visitorStorageKey = 'cinta_recommendation_visitor_v1';
  var visitorLifetime = 30 * 24 * 60 * 60 * 1000;

  function visitorId() {
    try {
      var now = Date.now();
      var stored = window.localStorage.getItem(visitorStorageKey);
      var visitor = null;
      try { visitor = stored ? JSON.parse(stored) : null; } catch (error) {}
      if (visitor && /^[a-f0-9]{32}$/.test(visitor.id) && visitor.expiresAt > now && visitor.expiresAt <= now + visitorLifetime) return visitor.id;
      if (!window.crypto || !window.crypto.getRandomValues) return null;
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      var id = Array.prototype.map.call(bytes, function (byte) { return ('0' + byte.toString(16)).slice(-2); }).join('');
      window.localStorage.setItem(visitorStorageKey, JSON.stringify({ id: id, expiresAt: now + visitorLifetime }));
      return id;
    } catch (error) { return null; }
  }

  function send(link) {
    var eventData = {
      type: link.getAttribute('data-recommendation-type'),
      sourceId: link.getAttribute('data-source-product-id'),
      sourceHandle: link.getAttribute('data-source-product-handle'),
      sourceTitle: link.getAttribute('data-source-product-title'),
      targetId: link.getAttribute('data-target-product-id'),
      targetHandle: link.getAttribute('data-target-product-handle'),
      targetTitle: link.getAttribute('data-target-product-title'),
      position: link.getAttribute('data-recommendation-position'),
      visitorId: visitorId()
    };
    var body;
    try { body = new Blob([JSON.stringify(eventData)], { type: 'text/plain;charset=UTF-8' }); }
    catch (error) { return; }
    if (navigator.sendBeacon) {
      try { if (navigator.sendBeacon(endpoint, body)) return; } catch (error) {}
    }
    if (window.fetch) {
      fetch(endpoint, { method: 'POST', body: body, mode: 'no-cors', credentials: 'omit', keepalive: true }).catch(function () {});
    }
  }

  function handle(event, expectedButton) {
    if (event.button !== expectedButton || event.defaultPrevented || (window.Shopify && (Shopify.designMode || Shopify.inspectMode))) return;
    var target = event.target && event.target.closest ? event.target.closest(selector) : null;
    if (target) send(target);
  }

  document.addEventListener('click', function (event) { handle(event, 0); }, true);
  document.addEventListener('auxclick', function (event) { handle(event, 1); }, true);
})();
